import React from 'react';

// Inline error next to the thing that failed. Renders nothing without a message.
const ErrorBanner = ({ message, className = '' }) =>
    message ? (
        <div role="alert" className={`text-xs text-red-600 bg-red-50 rounded-lg px-3 py-2 ${className}`}>
            {message}
        </div>
    ) : null;

export default ErrorBanner;
